var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"stroke no-fill"},[_c('path',{attrs:{"d":"M12.5048 1L16.0513 8.57L24 9.79L18.2476 15.68L19.6073 24L12.5048 20.07L5.39272 24L6.75238 15.68L1 9.79L8.94874 8.57L12.5048 1Z","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }